export const API_NAME = "premiumPlan";
export const ROUTE_NAME = "premiumPlan";
export const COMPONENT_NAMES = ["premiumPlan", "premiumPlans"];
